<div class="container-fluid daily-expense-page">

  <!-- Page header -->
  <div class="expense-header d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
    <div>
      <h4 class="mb-1">
        {{ isEditMode ? 'Edit Daily Expense' : 'Add Daily Expense' }}
      </h4>

      <p class="text-muted mb-0">
        Manage your daily expense details and bill attachment.
      </p>
    </div>

    <!-- <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="cancel()"
      [disabled]="saving || deletingBill">

      <i class="bi bi-arrow-left me-1"></i>
      Back to Expenses
    </button> -->
  </div>

  <!-- Form card -->
  <div class="card expense-card">
    <div class="card-body p-3 p-md-4">

      <div *ngIf="loadingExpense" class="alert alert-info">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading expense details...
      </div>

      <form
        [formGroup]="expenseForm"
        (ngSubmit)="saveExpense()"
        novalidate>

        <div class="row g-3">

          <!-- Expense name -->
          <div class="col-12 col-md-6">
            <label for="expenseSeq" class="form-label">
              Expense Name
              <span class="text-danger">*</span>
            </label>

            <select
              id="expenseSeq"
              class="form-select"
              formControlName="expenseSeq"
              [class.is-invalid]="
                f.expenseSeq.touched && f.expenseSeq.invalid
              ">

              <option [ngValue]="null">
                Select expense name
              </option>

              <option
                *ngFor="let expense of expenseList"
                [ngValue]="expense.expenseSeq">

                {{ expense.name }}
              </option>
            </select>

            <div
              class="invalid-feedback"
              *ngIf="f.expenseSeq.touched && f.expenseSeq.invalid">

              Please select an expense name.
            </div>
          </div>

          <!-- Expense date -->
          <div class="col-12 col-md-6">
            <label for="expenseDate" class="form-label">
              Expense Date
              <span class="text-danger">*</span>
            </label>

            <input
              id="expenseDate"
              type="date"
              class="form-control"
              formControlName="expenseDate"
              [max]="today"
              [class.is-invalid]="
                f.expenseDate.touched && f.expenseDate.invalid
              ">

            <div
              class="invalid-feedback"
              *ngIf="f.expenseDate.touched && f.expenseDate.invalid">

              Please select an expense date.
            </div>
          </div>

          <!-- Amount -->
          <div class="col-12 col-md-6">
            <label for="amount" class="form-label">
              Amount (₹)
              <span class="text-danger">*</span>
            </label>

            <div class="input-group">
              <span class="input-group-text">₹</span>

              <input
                id="amount"
                type="number"
                class="form-control"
                formControlName="amount"
                min="0.01"
                max="999999999"
                step="0.01"
                placeholder="Enter amount"
                [class.is-invalid]="
                  f.amount.touched && f.amount.invalid
                ">
            </div>

            <div
              class="text-danger small mt-1"
              *ngIf="f.amount.touched && f.amount.invalid">

              Amount must be greater than zero.
            </div>
          </div>

          <!-- Description -->
          <div class="col-12">
            <label for="description" class="form-label">
              Description
              <span class="text-danger">*</span>
            </label>

            <textarea
              id="description"
              class="form-control"
              formControlName="description"
              rows="3"
              maxlength="1000"
              placeholder="Enter expense description"
              [class.is-invalid]="
                f.description.touched && f.description.invalid
              ">
            </textarea>

            <div
              class="invalid-feedback"
              *ngIf="
                f.description.touched && f.description.invalid
              ">

              Description is required.
            </div>
          </div>

          <!-- Bill file input -->
          <div class="col-12">
            <label for="billFile" class="form-label">
              Bill Attachment
            </label>

            <input
              #billFileInput
              id="billFile"
              type="file"
              class="form-control"
              accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
              capture="environment"
              (change)="onBillSelected($event)">

            <div class="form-text">
              Allowed formats: JPG, JPEG, PNG and PDF.
              Maximum file size: 2 MB.
              Only one bill is allowed per expense.
            </div>
          </div>

          <!-- Existing/new bill preview -->
          <div
            class="col-12"
            *ngIf="billPreview">

            <div class="col-12" *ngIf="billPreview">
  <div class="bill-preview-card">

    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
      <div>
        <div class="fw-semibold">
          {{ newBillSelected ? 'New Bill' : 'Saved Bill' }}
        </div>

        <div class="small text-muted">
          {{ selectedFileName || 'Expense attachment' }}
        </div>
      </div>

      <button
        *ngIf="existingBill && !newBillSelected"
        type="button"
        class="btn btn-sm btn-outline-danger"
        (click)="deleteSavedBill()"
        [disabled]="deletingBill || saving">

        {{ deletingBill ? 'Deleting...' : 'Delete Saved Bill' }}
      </button>

      <button
        *ngIf="newBillSelected"
        type="button"
        class="btn btn-sm btn-outline-secondary"
        (click)="clearSelectedBill(billFileInput)"
        [disabled]="saving">

        Remove Selection
      </button>
    </div>

    <img
      *ngIf="fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png'"
      [src]="billPreview"
      alt="Saved expense bill"
      class="bill-image-preview" width="150" height="150" style="object-fit: cover">

    <div *ngIf="fileType === 'pdf'" class="pdf-preview">
      <span>PDF bill attachment</span>

      <a
        [href]="billPreview"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-sm btn-outline-primary">

        View PDF
      </a>
    </div>

  </div>
</div>
          </div>

          <!-- No bill attached -->
          <div
            class="col-12"
            *ngIf="
              isEditMode &&
              !existingBill &&
              !newBillSelected
            ">

            <div class="alert alert-light border mb-0">
              <i class="bi bi-info-circle me-1"></i>
              No bill is attached to this expense.
            </div>
          </div>

        </div>

        <!-- Form actions -->
        <div class="d-flex flex-wrap justify-content-end gap-2 mt-4">

          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="cancel()"
            [disabled]="saving || deletingBill">

            Cancel
          </button>

          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="
              saving ||
              loadingExpense ||
              deletingBill
            ">

            <span
              *ngIf="saving"
              class="spinner-border spinner-border-sm me-1">
            </span>

            <i
              *ngIf="!saving"
              class="bi bi-check-circle me-1">
            </i>

            {{
              saving
                ? 'Please wait...'
                : (isEditMode ? 'Update Expense' : 'Save Expense')
            }}
          </button>

        </div>

      </form>
    </div>
  </div>
</div>